import { useState, useEffect, useCallback } from "react";
import api from "../axiosInstance";

// Cascading State -> University dropdown data. Pass the selected stateId;
// universities refetch whenever it changes and clear when it's unset.
function useStatesUniversities(stateId) {
  const [states, setStates] = useState([]);
  const [universities, setUniversities] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingUniversities, setLoadingUniversities] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoadingStates(true);
    api
      .get("/getAllStates")
      .then((res) => setStates(res.data.data || []))
      .catch((err) => {
        setError(err.response?.data?.message || err.message);
      })
      .finally(() => setLoadingStates(false));
  }, []);

  const fetchUniversities = useCallback(() => {
    if (!stateId) {
      setUniversities([]);
      return;
    }
    setLoadingUniversities(true);
    api
      .get(`/getUniversities/${stateId}`)
      .then((res) => setUniversities(res.data.data || []))
      .catch((err) => {
        setError(err.response?.data?.message || err.message);
        setUniversities([]);
      })
      .finally(() => setLoadingUniversities(false));
  }, [stateId]);

  useEffect(() => {
    fetchUniversities();
  }, [fetchUniversities]);

  return {
    states,
    universities,
    loadingStates,
    loadingUniversities,
    error,
    refreshUniversities: fetchUniversities,
  };
}

export default useStatesUniversities;
